import Surrounding1 from "../../Media/Surrounding/Surrounding (1).webp"
import Surrounding2 from "../../Media/Surrounding/Surrounding (2).webp"
import Surrounding3 from "../../Media/Surrounding/Surrounding (3).webp"
import Surrounding4 from "../../Media/Surrounding/Surrounding (4).webp"
import Surrounding5 from "../../Media/Surrounding/Surrounding (5).webp"
import Surrounding6 from "../../Media/Surrounding/Surrounding (6).webp"
import Surrounding7 from "../../Media/Surrounding/Surrounding (7).webp"
import Surrounding8 from "../../Media/Surrounding/Surrounding (8).webp"


const Surroundingimages =[
    Surrounding1,Surrounding2,Surrounding3,Surrounding4,Surrounding5,Surrounding6,Surrounding7,Surrounding8
]

export default Surroundingimages;